import Modal from 'components/Modal'
import CreateDrdMember from 'views/MemberLookup/ManualTx/CreateDrdMember'

const ModalCreateMember = ({
  title,
  open,
  onClose,
}: {
  title: string | undefined
  open: boolean
  onClose: () => void
}): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <CreateDrdMember onClose={onClose} />
    </Modal>
  )
}

export default ModalCreateMember
